import * as React from 'react'

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width='100%' height='100%' viewBox='0 0 434.787 238.833' {...props}>
      <defs>
        <linearGradient
          id='prefix__a'
          x1={0.5}
          y1={1.006}
          x2={0.5}
          y2={-0.358}
          gradientUnits='objectBoundingBox'
        >
          <stop offset={0.05} stopColor='#5c8cda' stopOpacity={0} />
          <stop offset={1} stopColor='#5c8cda' />
        </linearGradient>
        <linearGradient
          id='prefix__h'
          x1={0.5}
          y1={1.001}
          x2={0.5}
          y2={0.004}
          xlinkHref='#prefix__a'
        />
        <linearGradient
          id='prefix__b'
          x1={0.5}
          y1={0.178}
          x2={0.5}
          y2={0.996}
          gradientUnits='objectBoundingBox'
        >
          <stop offset={0} stopColor='#001d85' stopOpacity={0} />
          <stop offset={0.154} stopColor='#001d85' stopOpacity={0.035} />
          <stop offset={0.332} stopColor='#001d85' stopOpacity={0.141} />
          <stop offset={0.523} stopColor='#001d85' stopOpacity={0.318} />
          <stop offset={0.723} stopColor='#001d85' stopOpacity={0.565} />
          <stop offset={0.928} stopColor='#001d85' stopOpacity={0.875} />
          <stop offset={1} stopColor='#001d85' />
        </linearGradient>
        <linearGradient
          id='prefix__i'
          x1={6.362}
          y1={46.577}
          x2={6.362}
          y2={47.395}
          xlinkHref='#prefix__b'
        />
        <clipPath id='prefix__c'>
          <path
            data-name='Caminho 9'
            d='M429.764 58.692H384.2a10.735 10.735 0 00-10.735 10.735v26.767h4.032a10.736 10.736 0 0110.736 10.736v4.032h41.535a10.735 10.735 0 0010.732-10.735v-30.8a10.735 10.735 0 00-10.736-10.735z'
            fill='none'
          />
        </clipPath>
        <clipPath id='prefix__d'>
          <path
            data-name='Caminho 18'
            d='M377.493 96.194h-26.767v4.033a10.735 10.735 0 01-10.735 10.735h-4.033V152.5a10.736 10.736 0 0010.735 10.736h30.8a10.736 10.736 0 0010.736-10.736v-45.57a10.736 10.736 0 00-10.736-10.736z'
            fill='none'
          />
        </clipPath>
        <clipPath id='prefix__e'>
          <path
            data-name='Caminho 27'
            d='M346.693 73.459a10.735 10.735 0 01-10.735-10.735v-4.032h-41.535a10.736 10.736 0 00-10.736 10.735v30.8a10.736 10.736 0 0010.736 10.735h45.568a10.735 10.735 0 0010.735-10.735V73.459z'
            fill='none'
          />
        </clipPath>
        <clipPath id='prefix__g'>
          <path
            data-name='Caminho 36'
            d='M373.461 69.427A10.735 10.735 0 01384.2 58.692h4.033V17.156a10.736 10.736 0 00-10.74-10.735h-30.8a10.735 10.735 0 00-10.735 10.735v45.568a10.735 10.735 0 0010.735 10.735h26.768z'
            fill='none'
          />
        </clipPath>
        <radialGradient
          id='prefix__j'
          cx={0.5}
          cy={0.5}
          r={0.271}
          gradientTransform='matrix(1.49 .571 -2.716 2.148 1.113 -.86)'
          gradientUnits='objectBoundingBox'
        >
          <stop offset={0.315} stopColor='#001d85' />
          <stop offset={0.572} stopColor='#001d85' stopOpacity={0.588} />
          <stop offset={0.86} stopColor='#001d85' stopOpacity={0.165} />
          <stop offset={1} stopColor='#001d85' stopOpacity={0} />
        </radialGradient>
        <pattern
          id='prefix__f'
          preserveAspectRatio='none'
          width='100%'
          height='100%'
          viewBox='0 0 151 83'
        >
          <image
            width={151}
            height={83}
            xlinkHref='data:image/png;base64,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'
          />
        </pattern>
      </defs>
      <g data-name='Grupo 19'>
        <g data-name='Grupo 13'>
          <g data-name='Grupo 3'>
            <g data-name='Grupo 2' clipPath='url(#prefix__c)' transform='translate(-5.712 -3.733)'>
              <g data-name='Grupo 1'>
                <path
                  data-name='Caminho 1'
                  d='M309.823 110.962V84.827h-26.136v15.681a10.454 10.454 0 0010.455 10.454z'
                  fill='#d84800'
                />
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 2'
                    d='M309.823 84.827V58.692h-15.681a10.454 10.454 0 00-10.455 10.454v15.681z'
                    fill='#e15200'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 1'
                    fill='#e15200'
                    d='M309.823 84.827h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 2'
                    fill='#e26100'
                    d='M309.823 58.692h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 3'
                    fill='#e26100'
                    d='M335.958 84.827h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 4'
                    fill='#ec6b00'
                    d='M335.958 58.692h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 5'
                    fill='#ec6b00'
                    d='M362.093 84.827h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 6'
                    fill='#e57623'
                    d='M362.093 58.692h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 3'
                    d='M362.093 163.233V137.1h-26.135v15.682a10.455 10.455 0 0010.454 10.454z'
                    fill='#d84800'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 7'
                    fill='#e15200'
                    d='M335.958 110.962h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 4'
                    d='M388.229 152.779V137.1h-26.136v26.136h15.682a10.455 10.455 0 0010.454-10.457z'
                    fill='#e15200'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 8'
                    fill='#e26100'
                    d='M362.093 110.962h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 9'
                    fill='#e57623'
                    d='M388.229 84.827h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 10'
                    fill='#e28140'
                    d='M388.229 58.692h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 5'
                    d='M440.5 100.508V84.827h-26.136v26.135h15.681a10.453 10.453 0 0010.455-10.454z'
                    fill='#e28140'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 6'
                    d='M440.5 84.827V69.146a10.453 10.453 0 00-10.454-10.454h-15.682v26.135z'
                    fill='#dd8c54'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 11'
                    fill='#e57623'
                    d='M335.958 32.556h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 7'
                    d='M362.093 32.556V6.421h-15.681a10.454 10.454 0 00-10.454 10.454v15.681z'
                    fill='#e28140'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 12'
                    fill='#e28140'
                    d='M362.093 32.556h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 8'
                    d='M388.229 32.556V16.875a10.454 10.454 0 00-10.454-10.454h-15.682v26.135z'
                    fill='#dd8c54'
                  />
                </g>
              </g>
              <image
                data-name='Ret\xE2ngulo 13'
                width={47.642}
                height={25.677}
                transform='translate(346.112 88.927)'
                opacity={0.75}
                xlinkHref='data:image/png;base64,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'
                style={{
                  mixBlendMode: 'multiply',
                  isolation: 'isolate',
                }}
              />
            </g>
          </g>
          <g data-name='Grupo 6'>
            <g data-name='Grupo 5' clipPath='url(#prefix__d)' transform='translate(-5.712 -3.733)'>
              <g data-name='Grupo 4'>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 10'
                    d='M309.823 110.962V84.827h-26.136v15.681a10.454 10.454 0 0010.455 10.454z'
                    fill='#d84800'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 11'
                    d='M309.823 84.827V58.692h-15.681a10.454 10.454 0 00-10.455 10.454v15.681z'
                    fill='#e15200'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 14'
                    fill='#e15200'
                    d='M309.823 84.827h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 15'
                    fill='#e26100'
                    d='M309.823 58.692h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 16'
                    fill='#e26100'
                    d='M335.958 84.827h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 17'
                    fill='#ec6b00'
                    d='M335.958 58.692h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 18'
                    fill='#ec6b00'
                    d='M362.093 84.827h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 19'
                    fill='#e57623'
                    d='M362.093 58.692h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 12'
                    d='M362.093 163.233V137.1h-26.135v15.682a10.455 10.455 0 0010.454 10.454z'
                    fill='#d84800'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 20'
                    fill='#e15200'
                    d='M335.958 110.962h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 13'
                    d='M388.229 152.779V137.1h-26.136v26.136h15.682a10.455 10.455 0 0010.454-10.457z'
                    fill='#e15200'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 21'
                    fill='#e26100'
                    d='M362.093 110.962h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 22'
                    fill='#e57623'
                    d='M388.229 84.827h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 23'
                    fill='#e28140'
                    d='M388.229 58.692h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 14'
                    d='M440.5 100.508V84.827h-26.136v26.135h15.681a10.453 10.453 0 0010.455-10.454z'
                    fill='#e28140'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 15'
                    d='M440.5 84.827V69.146a10.453 10.453 0 00-10.454-10.454h-15.682v26.135z'
                    fill='#dd8c54'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 24'
                    fill='#e57623'
                    d='M335.958 32.556h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 16'
                    d='M362.093 32.556V6.421h-15.681a10.454 10.454 0 00-10.454 10.454v15.681z'
                    fill='#e28140'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 25'
                    fill='#e28140'
                    d='M362.093 32.556h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 17'
                    d='M388.229 32.556V16.875a10.454 10.454 0 00-10.454-10.454h-15.682v26.135z'
                    fill='#dd8c54'
                  />
                </g>
              </g>
              <image
                data-name='Ret\xE2ngulo 26'
                width={25.677}
                height={48.57}
                transform='translate(332.191 67.89)'
                opacity={0.75}
                xlinkHref='data:image/png;base64,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'
                style={{
                  mixBlendMode: 'multiply',
                  isolation: 'isolate',
                }}
              />
            </g>
          </g>
          <g data-name='Grupo 9'>
            <g data-name='Grupo 8' clipPath='url(#prefix__e)' transform='translate(-5.712 -3.733)'>
              <g data-name='Grupo 7'>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 19'
                    d='M309.823 110.962V84.827h-26.136v15.681a10.454 10.454 0 0010.455 10.454z'
                    fill='#d84800'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 20'
                    d='M309.823 84.827V58.692h-15.681a10.454 10.454 0 00-10.455 10.454v15.681z'
                    fill='#e15200'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 27'
                    fill='#e15200'
                    d='M309.823 84.827h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 28'
                    fill='#e26100'
                    d='M309.823 58.692h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 29'
                    fill='#e26100'
                    d='M335.958 84.827h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 30'
                    fill='#ec6b00'
                    d='M335.958 58.692h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 31'
                    fill='#ec6b00'
                    d='M362.093 84.827h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 32'
                    fill='#e57623'
                    d='M362.093 58.692h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 21'
                    d='M362.093 163.233V137.1h-26.135v15.682a10.455 10.455 0 0010.454 10.454z'
                    fill='#d84800'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 33'
                    fill='#e15200'
                    d='M335.958 110.962h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 22'
                    d='M388.229 152.779V137.1h-26.136v26.136h15.682a10.455 10.455 0 0010.454-10.457z'
                    fill='#e15200'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 34'
                    fill='#e26100'
                    d='M362.093 110.962h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 35'
                    fill='#e57623'
                    d='M388.229 84.827h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 36'
                    fill='#e28140'
                    d='M388.229 58.692h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 23'
                    d='M440.5 100.508V84.827h-26.136v26.135h15.681a10.453 10.453 0 0010.455-10.454z'
                    fill='#e28140'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 24'
                    d='M440.5 84.827V69.146a10.453 10.453 0 00-10.454-10.454h-15.682v26.135z'
                    fill='#dd8c54'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 37'
                    fill='#e57623'
                    d='M335.958 32.556h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 25'
                    d='M362.093 32.556V6.421h-15.681a10.454 10.454 0 00-10.454 10.454v15.681z'
                    fill='#e28140'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 38'
                    fill='#e28140'
                    d='M362.093 32.556h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 26'
                    d='M388.229 32.556V16.875a10.454 10.454 0 00-10.454-10.454h-15.682v26.135z'
                    fill='#dd8c54'
                  />
                </g>
              </g>
              <path
                data-name='Ret\xE2ngulo 39'
                transform='translate(330.644 54.897)'
                opacity={0.75}
                fill='url(#prefix__f)'
                style={{
                  mixBlendMode: 'multiply',
                  isolation: 'isolate',
                }}
                d='M0 0h45.347v25.677H0z'
              />
            </g>
          </g>
          <g data-name='Grupo 12'>
            <g data-name='Grupo 11' clipPath='url(#prefix__g)' transform='translate(-5.712 -3.733)'>
              <g data-name='Grupo 10'>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 28'
                    d='M309.823 110.962V84.827h-26.136v15.681a10.454 10.454 0 0010.455 10.454z'
                    fill='#d84800'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 29'
                    d='M309.823 84.827V58.692h-15.681a10.454 10.454 0 00-10.455 10.454v15.681z'
                    fill='#e15200'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 40'
                    fill='#e15200'
                    d='M309.823 84.827h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 41'
                    fill='#e26100'
                    d='M309.823 58.692h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 42'
                    fill='#e26100'
                    d='M335.958 84.827h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 43'
                    fill='#ec6b00'
                    d='M335.958 58.692h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 44'
                    fill='#ec6b00'
                    d='M362.093 84.827h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 45'
                    fill='#e57623'
                    d='M362.093 58.692h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 30'
                    d='M362.093 163.233V137.1h-26.135v15.682a10.455 10.455 0 0010.454 10.454z'
                    fill='#d84800'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 46'
                    fill='#e15200'
                    d='M335.958 110.962h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 31'
                    d='M388.229 152.779V137.1h-26.136v26.136h15.682a10.455 10.455 0 0010.454-10.457z'
                    fill='#e15200'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 47'
                    fill='#e26100'
                    d='M362.093 110.962h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 48'
                    fill='#e57623'
                    d='M388.229 84.827h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 49'
                    fill='#e28140'
                    d='M388.229 58.692h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 32'
                    d='M440.5 100.508V84.827h-26.136v26.135h15.681a10.453 10.453 0 0010.455-10.454z'
                    fill='#e28140'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 33'
                    d='M440.5 84.827V69.146a10.453 10.453 0 00-10.454-10.454h-15.682v26.135z'
                    fill='#dd8c54'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 50'
                    fill='#e57623'
                    d='M335.958 32.556h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 34'
                    d='M362.093 32.556V6.421h-15.681a10.454 10.454 0 00-10.454 10.454v15.681z'
                    fill='#e28140'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Ret\xE2ngulo 51'
                    fill='#e28140'
                    d='M362.093 32.556h26.135v26.135h-26.135z'
                  />
                </g>
                <g data-name='LWPOLYLINE'>
                  <path
                    data-name='Caminho 35'
                    d='M388.229 32.556V16.875a10.454 10.454 0 00-10.454-10.454h-15.682v26.135z'
                    fill='#dd8c54'
                  />
                </g>
              </g>
              <image
                data-name='Ret\xE2ngulo 52'
                width={25.677}
                height={46.404}
                transform='translate(366.221 53.35)'
                opacity={0.75}
                xlinkHref='data:image/png;base64,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'
                style={{
                  mixBlendMode: 'multiply',
                  isolation: 'isolate',
                }}
              />
            </g>
          </g>
        </g>
        <g data-name='Grupo 14' fill='#d84800'>
          <path
            data-name='Caminho 37'
            d='M334.048 201.713a27.6 27.6 0 00-13.136 3.516c-1.12-2.334-3.248-3.516-6.334-3.516-3.534 0-7.239.972-12.277 3.235l.061-3.353-10.469 1.772-6.076 34.772h11.791l3.87-22.094c2.734-1.392 6.432-2.849 7.834-2.849a2.836 2.836 0 01.32.014 5.44 5.44 0 01-.085.608l-4.259 24.322h11.724l3.87-22.025c2.811-1.435 6.468-2.918 7.9-2.918a2.814 2.814 0 01.319.014 5.212 5.212 0 01-.085.608l-4.26 24.321h11.791l4.3-24.5a20.354 20.354 0 00.366-4.075c-.002-5.21-2.412-7.852-7.165-7.852zm-6.92 34.435l3.813-21.768.038-.222a5.982 5.982 0 00.116-.987c0-.734-.3-1.966-2.313-1.966-2.253 0-7.044 2.205-9.263 3.371l-.433.227-3.75 21.345h-7.677l3.815-21.775.036-.215a6.084 6.084 0 00.115-.987c0-.734-.3-1.966-2.313-1.966-2.4 0-7.45 2.383-9.193 3.3l-.434.228-3.751 21.414h-7.746l5.426-31.051 6.713-1.136-.077 4.146 1.452-.687c5.5-2.6 9.349-3.715 12.877-3.715 2.681 0 4.183 1 4.867 3.244l.367 1.2 1.086-.631a26.084 26.084 0 0113.15-3.814c3.624 0 5.171 1.754 5.171 5.863a18.575 18.575 0 01-.332 3.709l-4.013 22.871z'
          />
          <path
            data-name='Caminho 38'
            d='M364.806 201.781c-9.787 0-16.739 2.521-18.857 14.82l-1.6 9.078c-.882 5.065-.461 8.415 1.328 10.543 1.476 1.757 3.811 2.611 7.137 2.611a18.283 18.283 0 009.908-2.809l.2 2.116h9.99l5.755-33.112.151-.864-.838-.259a46.757 46.757 0 00-13.174-2.124zm-.064 34.367l-.362-3.795-1.427 1.089a16.313 16.313 0 01-10.134 3.4c-2.7 0-4.536-.622-5.612-1.9-1.381-1.642-1.664-4.476-.891-8.917l1.6-9.08c1.4-8.13 4.716-13.169 16.894-13.169a44.464 44.464 0 0111.753 1.784l-5.318 30.59z'
          />
          <path
            data-name='Caminho 39'
            d='M363.004 210.096c-6.026 0-6.7 3.487-7.288 6.577l-1.734 10.065a3.252 3.252 0 00.467 2.8 3.037 3.037 0 002.389.847c3.34 0 6.48-2.231 8.054-3.56l.278-.232 2.793-15.925-.944-.2a20.352 20.352 0 00-4.015-.372zm-6.166 18.291c-.739 0-.875-.15-.876-.151s-.162-.2-.013-1.187l1.729-10.019c.622-3.248 1.14-4.942 5.326-4.942a20.8 20.8 0 012.656.166l-2.327 13.271c-2.272 1.842-4.573 2.862-6.495 2.862z'
          />
          <path
            data-name='Caminho 40'
            d='M400.599 186.706l-12.128 1.674-2.159 12.455 12.044-1.673zm-11.858 11.779l1.446-8.331 7.964-1.1-1.5 8.331z'
          />
          <path
            data-name='Caminho 41'
            d='M385.841 203.277l-6.153 34.863h11.79l6.484-36.536zm-3.778 32.871l5.487-31.1 7.972-1.1-5.712 32.2z'
          />
          <path
            data-name='Caminho 42'
            d='M415.656 211.395a36.093 36.093 0 018.255 1.211l1.016.282 2.008-9.255-.857-.278a37.059 37.059 0 00-10.354-1.642c-9.518 0-12.355 2.063-13.8 10.036-.959 5.382-.585 8.355 6.959 12.35 3.994 2.106 4.116 2.606 3.987 3.313-.238 1.369-.3 1.738-2.76 1.738a25.446 25.446 0 01-8.814-1.676l-1.024-.36-2.355 9.076.774.341a30.051 30.051 0 0010.865 2.3c10.79 0 13.254-3.544 14.7-11.488 1.115-6.131-.731-7.853-8.482-12.005-2.991-1.591-2.977-1.668-2.814-2.6.239-1.242.259-1.343 2.696-1.343zm6.641 15.592c-1.345 7.394-3.374 9.853-12.739 9.853a28.6 28.6 0 01-9.28-1.81l1.383-5.328a26.652 26.652 0 008.451 1.44c3.836 0 4.377-1.4 4.723-3.382.439-2.416-1.52-3.578-5.018-5.423-6.506-3.443-6.786-5.432-5.93-10.236 1.2-6.607 2.8-8.4 11.837-8.4a35.778 35.778 0 018.878 1.284l-1.179 5.435a37.789 37.789 0 00-7.767-1.021c-3.063 0-4.165.428-4.653 2.973-.429 2.455.819 3.118 3.835 4.721 7.812 4.189 8.289 5.335 7.459 9.894z'
          />
        </g>
        <g data-name='Grupo 18'>
          <path
            data-name='Caminho 43'
            d='M72.567 64.552a91.89 91.89 0 00-18.226 5.26q-4.073 1.7-7.921 3.777 0-5.086.007-10.171H.003v84.071c0 .044.011.088.016.132 0 .115-.011.23-.011.345v89.563h46.4v-3.178q0-41.773.032-83.548a40.806 40.806 0 01.637-8.38 39.984 39.984 0 015.735-14.117c8.02-11.971 19.158-18.449 33.609-18.955 4.832-.169 9.675-.026 14.512-.026h.857v-45.9c-.191.004-19.681-.693-29.223 1.127z'
            fill='#001d85'
          />
          <g data-name='Grupo 15'>
            <path
              data-name='Caminho 44'
              d='M278.741 138.315a85.93 85.93 0 00-6.348-22.307 84.6 84.6 0 00-19.422-27.822 87.1 87.1 0 00-60.011-24.185c-12.878-.031-40.545-.084-41.767-.138V0h-46.12c0 21.135.026 134.184.088 146.471.021 4.1.291 8.2.469 12.3a74.249 74.249 0 004.63 21.6 85.6 85.6 0 0015.141 26.556 87.259 87.259 0 0034.067 25.033 78.6 78.6 0 0023.609 6.008c25.85 2.15 47.759-5.1 63.732-18.414 13.216-11.015 23.4-24.289 28.391-41a128.516 128.516 0 003.857-17.222 77.666 77.666 0 00-.316-23.017zm-45.846 20.282a39.643 39.643 0 01-15.442 25.544c-9.188 7.065-19.695 9.47-31.111 7.874a39.872 39.872 0 01-23.682-12.048 38.662 38.662 0 01-10.443-19.706 55.11 55.11 0 01-.993-10.06c-.11-12.546-.039-25.094-.036-37.641v-2.556h2.5c12.678 0 25.356.051 38.034-.008 13.077-.062 24.017 4.8 32.386 14.722 8.239 9.775 10.929 21.269 8.787 33.879z'
              fill='#001d85'
            />
          </g>
          <g data-name='Grupo 17'>
            <path
              data-name='Caminho 45'
              d='M78.279 68.285a91.89 91.89 0 00-18.226 5.26q-4.073 1.7-7.921 3.777 0-5.086.007-10.171H5.715v84.071c0 .044.011.088.016.132 0 .115-.011.23-.011.345v89.563h46.4v-3.178q0-41.773.032-83.548a40.806 40.806 0 01.637-8.38 39.984 39.984 0 015.735-14.117c8.02-11.971 19.158-18.449 33.609-18.955 4.832-.169 9.675-.026 14.512-.026h.857v-45.9c-.191.004-19.681-.693-29.223 1.127z'
              fill='url(#prefix__a)'
              transform='translate(-5.712 -3.733)'
            />
            <g data-name='Grupo 16'>
              <path
                data-name='Caminho 46'
                d='M284.453 142.048a85.93 85.93 0 00-6.348-22.307 84.6 84.6 0 00-19.422-27.822 87.1 87.1 0 00-60.011-24.185c-12.878-.031-40.545-.084-41.767-.138V3.733h-46.12c0 21.135.026 134.184.088 146.471.021 4.1.291 8.2.469 12.3a74.249 74.249 0 004.63 21.6 85.6 85.6 0 0015.141 26.556 87.259 87.259 0 0034.067 25.033 78.6 78.6 0 0023.609 6.008c25.85 2.15 47.759-5.1 63.732-18.414 13.216-11.015 23.4-24.289 28.391-41a128.516 128.516 0 003.857-17.222 77.666 77.666 0 00-.316-23.017zm-45.846 20.282a39.643 39.643 0 01-15.442 25.544c-9.188 7.065-19.695 9.47-31.111 7.874a39.872 39.872 0 01-23.682-12.048 38.662 38.662 0 01-10.443-19.706 55.11 55.11 0 01-.993-10.06c-.11-12.546-.039-25.094-.036-37.641v-2.556h2.5c12.678 0 25.356.051 38.034-.008 13.077-.062 24.017 4.8 32.386 14.722 8.239 9.775 10.929 21.269 8.787 33.879z'
                fill='url(#prefix__h)'
                transform='translate(-5.712 -3.733)'
              />
            </g>
          </g>
          <path
            data-name='Caminho 47'
            d='M156.8 48.14h-46.015v19.074l46.019.412z'
            opacity={0.45}
            fill='url(#prefix__b)'
            transform='translate(-5.712 -3.733)'
          />
          <path
            data-name='Caminho 48'
            d='M110.853 133.215h46.019v-19.487l-46.019-.671z'
            opacity={0.45}
            fill='url(#prefix__i)'
            transform='translate(-5.712 -3.733)'
          />
          <path
            data-name='Caminho 49'
            d='M5.715 67.151v84.111c.007.062.016.122.021.184h.008c0-.031-.008-.061-.011-.092.086-5.362 1.231-10.737 2.125-16.064 1.492-8.9 5-17.079 9.546-24.8a86.077 86.077 0 0123.19-25.816 95.056 95.056 0 0111.533-7.343q0-5.088.007-10.175z'
            opacity={0.45}
            fill='url(#prefix__j)'
            transform='translate(-5.712 -3.733)'
          />
        </g>
      </g>
    </svg>
  )
}

export default SvgComponent
